import { useEffect, useState } from 'react';
// eslint-disable-next-line no-restricted-imports -- FIXME: This rule was recently enabled for the repo
import { useTheme } from '@mui/material';

export function useIsMobileMediaQuery() {
  const theme = useTheme();
  const [mounted, setMounted] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setMounted(true);
    setIsMobile(window.matchMedia(theme.breakpoints.down('sm')).matches);
  }, [theme]);

  return mounted && isMobile;
}
